import { SetupDataStore, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { TechnicianLoanBanner } from '../../components/TechnicianLoanBanner';
import { useApprovedLoanBanner } from '../../hooks/useApprovedLoanBanner';

export const Container = () => {
    const { setupData } = SetupDataStore.useStore();
    const { showTechnicianLoanBanner } = useProviderConfig();

    const { approvedLoan, shouldShowBanner, handleContinueClick, isLoading } =
        useApprovedLoanBanner({
            tenantId: setupData?.tenantId ?? '',
            customerId: setupData?.customerId ?? '',
            buId: setupData?.buId ?? '',
            currentJobId: setupData?.jobId ?? '',
            showTechnicianLoanBanner: showTechnicianLoanBanner ?? false,
        });

    if (!shouldShowBanner || !approvedLoan) {
        return null;
    }

    return (
        <TechnicianLoanBanner
            loan={approvedLoan}
            onContinueClick={handleContinueClick}
            loading={isLoading}
        />
    );
};
